import { render, staticRenderFns } from "./BxTable.vue?vue&type=template&id=00667fec&"
import script from "./BxTable.vue?vue&type=script&lang=js&"
export * from "./BxTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports